import { useMemo, useState } from 'react'
import * as RetornoHttp from '../../../../../services/api/https/deliveries/retorno.http'

import { errorHandler } from '../../../../../services/util/error.service'
import { DateTime } from 'luxon'

export const LOAD_MESSAGE = {
  NONE: 'NONE',
  LOADING_EDIT: 'Adquirindo informações para edição',
  SAVE_UPDATE: 'Atualizando cliente',
  SUCCESS: 'Cliente cadastrado',
}

const INITIAL_ENTREGA = {
  delivery_step_vehicle_id: 0,
  delivery_id: 0,
  delivery_step_id: 0,
  identifier: '',
  nomeFantasia: '',
  city: 'BARREIRAS',
  district: 'BOA VISTA',
  load_order: 0,
  qte_sku: 0,
  status: '',
  qte_faltas: null,
  delivery_event_id: 0,
  deliveried_date: '',
  deliveried_date_formatted: '',
}

const FIELD_ERRORS_MESSAGE = {
  deliveried_date: 'O campo Razão Social precisa ser preenchido',
}

export const INITIAL_STATE = {
  entrega: { ...INITIAL_ENTREGA },
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
}

export default function useModalInformacoes() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    const throwError = fieldName =>
      setState(prevState => ({ ...prevState, errorMessage: FIELD_ERRORS_MESSAGE[fieldName] }))

    const fieldIsValid = field =>
      field && field !== 0 && (typeof field === 'string' ? field.trim() !== '' : true)

    const areFieldsValid = ({ deliveried_date }) => {
      const fields = { deliveried_date }
      let fieldsNames = Object.keys(fields)
      return fieldsNames.every(fieldName => {
        if (!fieldIsValid(fields[fieldName])) {
          throwError(fieldName)
          return false
        }
        return true
      })
    }

    return {
      // Actions
      saveUpdateDelivery(entrega) {
        const deliveried_date = DateTime.fromJSDate(entrega.deliveried_date_formatted).toISO()
        RetornoHttp.putDeliveriedDate(entrega.delivery_event_id, deliveried_date)
          .then(() =>
            setState(prevState => ({
              ...prevState,
              loadingMessage: LOAD_MESSAGE.SUCCESS,
            })),
          )
          .catch(err => setState(prevState => ({ ...prevState, errorMessage: errorHandler(err) })))
      },

      resetState() {
        setState(prevState => ({
          ...prevState,
          ...INITIAL_STATE,
        }))
      },

      resetError() {
        setState(prevState => ({
          ...prevState,
          errorMessage: null,
          loadingMessage: LOAD_MESSAGE.NONE,
        }))
      },

      // Events
      onInit(entrega) {
        setState(prevState => {
          prevState = { ...INITIAL_STATE }
          prevState.entrega = entrega
          if (entrega.deliveried_date)
            prevState.entrega.deliveried_date_formatted = new Date(entrega.deliveried_date)
          prevState.loadingMessage = LOAD_MESSAGE.NONE
          return { ...prevState }
        })
      },

      onInputChange(name, value) {
        setState(prevState => {
          prevState.entrega[name] = value
          return { ...prevState }
        })
      },

      onBtnSalvarClicked(entrega) {
        if (areFieldsValid(entrega)) {
          setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.SAVE_UPDATE }))
        }
      },
    }
  }, [])

  return { state, localDispatch }
}
